import { DocumentContentSection } from "../DocumentContentSection";
import { DocumentSignature } from "../DocumentSignature";
import { DocumentTitle } from "../DocumentTitle";

export const TermsOfService = () => {
  return (
    <div className="w-full min-h-screen bg-white">
      <div className="flex flex-col min-h-[calc(100vh-72px)] p-4 sm:px-8">
        <div className="flex flex-col gap-6">
          <DocumentTitle title="利用規約" releaseDate="2025年 3月 10日" lastUpdated="2025年 3月 10日" />

          <div className="text-sm leading-7">
            <p className="mb-8">
              本規約は、株式会社Masentic(以下「当社」といいます。)が運営し提供するサービス「サンバ」(以下「本サービス」といい、本サービスにおいて提供される個別のゲームを以下「本ゲーム」といいます。)の利用条件を定めるものです。本サービス利用前に、本規約およびプライバシーポリシーをご確認ください。本規約に同意いただけない場合には、本サービスをご利用いただくことはできません。
            </p>

            <DocumentContentSection title="第1条(適用範囲)">
              <p>
                (1)
                本規約は、本サービスの提供条件および本サービスの利用に関する当社と会員(第2条に規定する会員登録を完了した者をいいます。)の権利義務関係を定めるものであり、当社と会員との間の本サービスの利用に関する一切の関係に適用されます。
              </p>
              <p>
                (2)当社が当社Webサイト上に掲載する本サービスの利用に関する利用ルール(
                <a href="https://half-pressure-b6c.notion.site/1b1941dfbe4080149e31cdc1c4e6cbfc">
                  https://half-pressure-b6c.notion.site/1b1941dfbe4080149e31cdc1c4e6cbfc
                </a>
                )は、本規約の一部を構成するものとします。
              </p>
              <p className="mb-8">
                (3)
                本規約の内容と、前項のルールその他の本規約外における本サービスの説明等とが異なる場合は、本規約の規定が優先して適用されるものとします。
              </p>
            </DocumentContentSection>

            <DocumentContentSection title="第2条(会員登録)">
              <p>
                (1)
                本サービスの利用を希望する者は、本規約およびプライバシーポリシ－の全文を確認の上で、これらを遵守することに同意し、当社の定める方法により会員登録の申請を行うものとします。
              </p>
              <p>
                (2)
                当社は、前項の規定により登録を申請した者について、登録の適否を判断し、申請者が以下のいずれかに該当する場合、会員登録を承認しないことがあります。
              </p>
              <p>① 登録申請内容に虚偽、誤記または漏れがあった場合。</p>
              <p>② 過去に本規約違反等により会員資格の停止・取消等の処分を受けていることが判明した場合。</p>
              <p>
                ③
                反社会的勢力等(暴力団、暴力団員、右翼団体、反社会的勢力、その他これに準ずるものをいいます。以下同じ。)である、または、資金提供その他を通じて反社会的勢力等の維持、運営もしくは経営に協力もしくは関与する等反社会的勢力等との何らかの交流もしくは関与を行っていると当社が判断した場合。
              </p>
              <p>④ 当社ならびにその子会社および関連会社の従業員およびその近親者に該当する場合。</p>
              <p>
                ⑤
                プロスポーツ選手(クラブと契約を結び、日常の出費を上回る給料をプロスポーツ選手としての活動により支払われている者、およびその近親者)ならびにプロスポーツ選手のエージェント、チームのコーチ、チームのオーナー、チームの従業員、審判員またはリーグの役員、およびその近親者に該当する場合。
              </p>
              <p>⑥ 当社のスポンサーまたはコンサルタントに該当する場合。</p>
              <p>
                ⑦
                当社のリリース前にスポーツデータにアクセスできる等、本サービスの利用において、有利となりうる未公開の情報にアクセスできる者に該当する場合。
              </p>
              <p className="mb-8">⑧ その他当社が会員登録を不適当と判断した場合。</p>
            </DocumentContentSection>

            <DocumentContentSection title="第3条(IDおよびパスワードの管理)">
              <p className="mb-8">
                会員は、当社が発行する会員IDおよびパスワードを自己の責任で適切に管理するものとします。会員は、自己のIDおよびパスワードを第三者に使用させてはならず、貸与、譲渡、名義変更、売買等を行ってはなりません。会員IDおよびパスワードの管理不十分、使用上の過誤、第三者の使用による損害については、会員がその責任を負うものとし、当社は一切の責任を負いません。
              </p>
            </DocumentContentSection>

            <DocumentContentSection title="第4条(本サービスの利用環境)">
              <p className="mb-8">
                会員は、本サービスを利用するために必要な通信機器、ソフトウェア、通信手段等を自己の費用と責任で整備するものとします。また、本サービスの利用に際して発生する通信費用等は会員が負担するものとします。当社は、会員の利用環境について一切関与せず、それに起因して会員に生じた不利益や障害について一切の責任を負いません。
              </p>
            </DocumentContentSection>

            <DocumentContentSection title="第5条(本規約の変更)">
              <p className="mb-8">
                当社は、必要に応じて本規約を変更することができるものとします。変更後の本規約は、当社が運営するウェブサイト上での掲示その他当社所定の方法により会員に通知した時点、または当社が別途定める効力発生日から効力を生じるものとします。なお、本規約の変更に伴い会員に生じた不利益・損害について、当社は一切の責任を負いません。
              </p>
            </DocumentContentSection>

            <DocumentContentSection title="第6条(会員情報の取扱い)">
              <p>
                (1)
                当社による会員の情報の取扱いについては、別途当社のプライバシーポリシーに定めるところによるものとし、会員は、当社が当該プライバシーポリシーに従って会員の情報を取り扱うことに同意します。
              </p>
              <p className="mb-8">
                (2)
                当社は、会員が当社に提供した情報、データ等を、個人を特定できない形での統計的な情報として、利用および公開することができるものとします。
              </p>
            </DocumentContentSection>

            <DocumentContentSection title="第7条(通知)">
              <p className="mb-8">
                当社から会員への連絡または通知は、会員が登録した電子メールアドレスへの送信、本サービス上での掲示、その他当社が適当と認める方法により行うものとします。電子メールによる通知の場合、当社が当該メールを発信した時点で、通知は会員に到達したものとみなします。会員は、常に連絡が取れる有効なメールアドレスを登録・維持する責任を負います。
              </p>
            </DocumentContentSection>

            <DocumentContentSection title="第8条(禁止事項)">
              <p>会員は、本サービスの利用にあたり、以下の行為を行ってはなりません。</p>
              <p>法令または公序良俗に違反する行為、犯罪行為に関連する行為。</p>
              <p>② 当社または第三者の権利(知的財産権、プライバシー権、パブリシティ権、名誉等)を侵害する行為。</p>
              <p>③ 他の会員の権利または財産を侵害する行為</p>
              <p>④ 当社のサービス運営を妨害し、またはその信用を毀損する行為。</p>
              <p>⑤ 虚偽の情報を提供する行為、または自己以外の人物になりすます行為。</p>
              <p>⑥ 一人の会員が複数のアカウントを不正に取得・利用する行為。</p>
              <p>⑦ 本サービスを不正の目的で利用する行為、または第三者をして不正利用させる行為。</p>
              <p>⑧ わいせつな情報を投稿または表示する行為</p>
              <p>
                ⑨
                本サービス内で取得した一切のコンテンツ、ポイント、または特典について、第三者による仲介又はインターネットオークション等その手段を問わず、売買その他、金銭その他現実世界における対価を授受する形でのあらゆる譲渡、譲受、貸与、借用等する行為。
              </p>
              <p className="mb-8">⑩ その他当社が不適切と判断する行為。</p>
            </DocumentContentSection>

            <DocumentContentSection title="第9条(会員資格の一時停止・取消)">
              <p>
                (1)
                当社は、会員が以下のいずれかに該当すると判断した場合、事前の通知なく当該会員の会員資格を一時停止し、または取消すことができるものとします。
              </p>
              <p>① 本規約の2条2項各号のいずれかの条項その他本規約の条項に違反した場合。</p>
              <p>② 法令に違反する行為、または違法行為に関連する行為を行った場合。</p>
              <p>③ 会員登録時に提供された情報に虚偽があることが判明した場合。</p>
              <p>④ 本サービスの運営を故意に妨害した場合。</p>
              <p>⑥ その他当社が会員として不適当と判断した場合。</p>
              <p>
                (2)
                当社が不正行為を行ったと判断した会員については、当社の裁量により当該会員のアカウントを削除することができるものとします。
              </p>
              <p className="mb-8">
                (3)
                会員資格が取消された場合、当該会員は取消時における本サービスに関する一切の権利を失うものとし、保有ポイントや未受領の特典(会員が一定の条件を充たした場合に受領することのできる賞品をいます。以下同じ。)に関する権利等も全て失効します。
              </p>
            </DocumentContentSection>

            <DocumentContentSection title="第10条(未成年者による本サービスの利用)">
              <p>(1) 未成年者が本サービスを利用する場合、事前に親権者等の法定代理人の承諾を得るものとします。</p>
              <p>
                (2)
                未成年者が前項に定める法定代理人の承諾を得ていないにもかかわらず、承諾を得ていると偽って本サービスを利用した場合または年齢について成年者と偽って本サービスを利用した場合など行為能力者であることを信じさせるため詐術を用いたときは、当該未成年者は、本サービスにおける一切の法律行為を取り消すことができないものとします。
              </p>
              <p>
                (3)
                本規約の同意時に未成年であった会員が成年に達した後に本サービスを利用した場合、当該会員は本サービスに関する一切の法律行為を追認したものとみなされます。
              </p>
              <p className="mb-8">
                (4)
                前各項にかかわらず、当社は、会員の年齢に応じて、本サービスの一部または全部の利用を制限する場合があります。なお、当社が当該制限を行う場合、事前に本サイト上への掲載その他当社所定の方法により、当該会員に通知するものとします。
              </p>
            </DocumentContentSection>

            <DocumentContentSection title="第11条(退会)">
              <p>
                (1)
                会員は、当社所定の方法で退会の申請を行うことにより、任意に本サービスを退会できるものとします。退会申請が完了した時点で、会員は本サービスの利用を終了し、退会時に保有する全てのポイントおよび未受領の特典に関する権利は失効します。
              </p>
              <p>
                (2)
                会員が死亡した場合、または会員について破産手続開始、民事再生手続開始その他これらに準ずる手続の申立てがあった場合、当社は当該会員が退会したものとみなします。
              </p>
              <p className="mb-8">
                (3)
                前項の場合のほか、会員が登録した電子メールアドレスが不通となり連絡が取れない状態が一定期間継続した場合、当社は当該会員が退会したものとみなすことができます。
              </p>
            </DocumentContentSection>

            <DocumentContentSection title="第12条(広告の配信)">
              <p className="mb-8">
                会員は、本サービス上で当社または第三者の広告が表示される場合があること、また当社から会員宛に電子メール等で広告やマーケティング情報が送信される場合があることをあらかじめ承諾するものとします。当社は、当社または第三者が本サービス上で提供する広告の内容について一切の保証を行わず、会員に生じた損害等について一切の責任を負いません。
              </p>
            </DocumentContentSection>

            <DocumentContentSection title="第13条(ポイントの付与)">
              <p>
                (1)
                会員は、本サービスの利用または本サービスを経由して当社提携先のサービスを利用し、当社および提携先が定める条件を満たした場合に、当社が別途定める基準に従いポイントが付与されます。ポイント付与の対象や条件、付与率等は当社が自由に定めることができ、会員はこれを異議なく承諾するものとします。
              </p>
              <p>
                (2)
                前項に基づきポイントが付与された後であっても、当社または提携先が会員の利用行為が条件を満たしていないと判断した場合、当社は当該ポイントを取り消すことができます。また、システムの不具合等により誤ってポイントが付与された場合には、当社はその誤付与分を訂正するためにポイント残高の調整を行うことができます。
              </p>
              <p>
                (3)
                会員が本サービスを利用して提携先の商品購入やサービス利用等の行為を行った場合であっても、提携先において当該行為が条件を充たしていない等の理由により有効と認められなかった場合は、ポイントは付与されません。当社および提携先は、有効であると認めなかった理由について会員に説明する義務を負わないものとします。
              </p>
              <p>
                (4)
                付与されたポイントは会員本人に帰属し、第三者への譲渡、貸与、相続等はできません。また、会員間でのポイントの共有・移転・売買等も禁止します。
              </p>
              <p>
                (5)
                会員に付与されたポイントは財産的価値と有するものではなく、会員は、付与されたポイントを金銭その他の財物に交換することはできません。
              </p>
              <p className="mb-8">
                (6)
                会員は、保有するポイントに有効期限または上限が定められる場合、当該条件に従ってポイントを管理・利用するものとします。期限切れ等により失効したポイントについて、当社は一切の補填を行わず、また、責任を負いません。
              </p>
            </DocumentContentSection>

            <DocumentContentSection title="第14条(特典)">
              <p>
                (1)
                会員は、本ゲームをプレイすること、および本ゲーム毎に設定された本特典を獲得することを目的として本ゲームに参加することを確認のうえ、本サービスを利用するものとします。
              </p>
              <p>
                (2)
                会員は、所定の手続により、当社の定める条件に従って特典を取得することができます。取得可能な特典の種類、取得のルール等は当社が決定し、本サービス上で表示します。
              </p>
              <p>
                (3)
                会員は、本ゲーム終了の90日以内、または特典付与前に別途当社が定めた期間内にのみ特典取得の申請を行うことができるものとします。
              </p>
              <p>
                (4)
                特典取得の申請後、当社所定の承認手続を経て特典の提供が行われます。特典の提供には所定の時間を要する場合があり、会員はこれを承諾するものとします。
              </p>
              <p>
                (5)
                当社は、特典の内容や条件を必要に応じて変更または中止することができます。この場合、当社は変更内容を本サービス上での掲示その他適切な方法で会員に周知します。
              </p>
              <p>
                (6)
                会員が不正な手段で獲得したポイントを利用して特典を取得しようとした場合、当社は当該申請を拒否し、必要に応じて会員資格の取消等の措置を取ることができます。
              </p>
              <p>
                (7)
                会員が取得する特典については、会員および当社以外の第三者(スポンサー)から提供された資金が原資になっております。
              </p>
              <p className="mb-8">
                (8) 当社は、各ゲームにおける賞金の設定等に当たり、不当景品類及び不当表示防止法等の関係法令を遵守します。
              </p>
            </DocumentContentSection>

            <DocumentContentSection title="第15条(特典の紛失等)">
              <p className="mb-8">
                当社は、特典の配送中に生じた遅延、紛失、盗難、破損等の事故について一切の責任を負いません。ただし、当社の故意または重過失による場合を除きます。会員は、特典の受領に際して生じた問題については、自身の責任と費用において対処するものとします。
              </p>
            </DocumentContentSection>

            <DocumentContentSection title="第16条(ポイントの取消)">
              <p>
                会員が以下のいずれかに該当すると当社が判断した場合、当社は当該会員の保有するポイントの一部または全部を取り消すことができるものとします。
              </p>
              <p>① 会員が本規約に違反した場合。 </p>
              <p>② 不正な手段でポイントを取得したことが判明した場合。 </p>
              <p>③ システムエラー、障害等により本来付与されるべきでないポイントが付与された場合。</p>
              <p className="mb-8">④ その他当社がポイントを取消す相当の理由があると認めた場合。</p>
            </DocumentContentSection>

            <DocumentContentSection title="第17条(知的財産権)">
              <p className="mb-8">
                本サービスにおいて提供されるすべてのコンテンツ(文章、画像、プログラム等)に関する知的財産権は、当社または当該コンテンツ提供者に帰属します。会員は、当社の事前の承諾なく、これらのコンテンツを複製、転載、改変、頒布、公衆送信する等の行為をしてはなりません。万一会員と第三者との間で本サービス上のコンテンツに関して紛争が生じた場合、会員の費用と責任において解決するものとし、当社は一切の責任を負いません。
              </p>
            </DocumentContentSection>

            <DocumentContentSection title="第18条(権利義務の譲渡禁止)">
              <p className="mb-8">
                会員は、当社の書面による事前の承諾なく、本サービスに関する会員としての地位または本サービスに関する権利もしくは義務の全部または一部を第三者に譲渡、貸与、担保提供し、または承継させることはできません。当社は、会員による本条違反行為が判明した場合、当該行為を無効とし、必要に応じて会員資格の取消その他適切な措置を講じることができます。
              </p>
            </DocumentContentSection>

            <DocumentContentSection title="第19条(責任の制限)">
              <p>
                (1)
                当社は、本サービスの提供、遅滞、変更、中断、停止、利用不能もしくは廃止、ポイントや特典の利用、その他本サービスに関連して会員に生じた損害について、当社の故意または重過失による場合を除き、一切の責任を負わないものとします。また、当社は、本サービスを通じて提供される情報の正確性、有用性等について何ら保証するものではありません。
              </p>
              <p className="mb-8">
                (2)
                会員が獲得したポイントまたは特典に起因して発生する税金、公的負担、キャッシュバックの振込手数料その他一切の費用は、会員の負担となります。万一ポイントまたは特典の取得・利用に関連して会員に税務上の義務が生じた場合であっても、会員自らの責任でこれを履行するものとし、当社は何ら関与しません。
              </p>
            </DocumentContentSection>

            <DocumentContentSection title="第20条(分離可能性)">
              <p>
                (1)
                本規約のいずれかの条項またはその一部が、消費者契約法その他の法令等により無効と判断された場合であっても、本規約の残りの規定および一部が無効と判断された規定の残りの部分は、継続して効力を有します。
              </p>
              <p className="mb-8">
                (2)
                本規約の全部または一部の定めが無効とされうる場合であっても、当該定めはこれが有効とされるように合理的かつ限定的に解釈されます。
              </p>
            </DocumentContentSection>

            <DocumentContentSection title="第21条(準拠法および管轄裁判所等)">
              <p>(1) 本規約は、日本法に準拠し、日本法に従って解釈されます。</p>
              <p>
                (2)
                本規約は、日本語を正文とします。本規約につき、参考のために英語による翻訳文が作成された場合でも、日本語の正文のみが契約としての効力を有するものとし、英訳はいかなる効力も有しないものとします。
              </p>
              <p className="mb-8">
                (3)
                本規約に起因し、または関連する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
              </p>
            </DocumentContentSection>
            <p className="mb-8">附則:本規約は2025年3月10日から施行します。</p>
          </div>

          <DocumentSignature />
        </div>
      </div>
    </div>
  );
};
